import { useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import api from "../../axios";
import GuestLayout from "../../Layouts/GuestLayout";
import InputLabel from "../../Components/InputLabel";
import TextInput from "../../Components/TextInput";
import PrimaryButton from "../../Components/PrimaryButton";
import InputError from "../../Components/InputError";

export default function PasswordReset() {
  const { token } = useParams(); // Get token from URL params
  const [searchParams] = useSearchParams(); // Get email from query params
  const navigate = useNavigate();
  const [email] = useState(searchParams.get("email") || "");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      setErrors({}); // Clear errors
      const response = await api.post("/reset-password", {
        email,
        password,
        password_confirmation: passwordConfirmation,
        token,
      });
      setStatus("Επιτυχής επαναφορά κωδικού πρόσβασης! Ανακατεύθυνση για σύνδεση...");
      setTimeout(() => navigate("/login"), 3000); // Redirect to login page after success
    } catch (err) {
      setErrors(err.response?.data?.errors || {});
    }
  };

  return (
    <GuestLayout>
      <h1 className="text-2xl font-bold mb-6 text-center">Επαναφορά κωδικού πρόσβασης</h1>
      <form onSubmit={submit}>
        <div>
          <InputLabel htmlFor="email" value="Email" />
          <TextInput id="email" type="email" value={email} disabled />
        </div>

        <div className="mt-4">
          <InputLabel htmlFor="password" value="Νέος κωδικός πρόσβασης" />
          <TextInput
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <InputError message={errors.password} />
        </div>

        <div className="mt-4">
          <InputLabel htmlFor="passwordConfirmation" value="Επιβεβαίωση κωδικού πρόσβασης" />
          <TextInput
            id="passwordConfirmation"
            type="password"
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            required
          />
          <InputError message={errors.password_confirmation} />
        </div>

        {status && <p className="text-sm text-green-600 mt-4">{status}</p>}

        <div className="mt-4">
          <PrimaryButton type="submit">Επαναφορά κωδικού πρόσβασης</PrimaryButton>
        </div>
      </form>
    </GuestLayout>
  );
}
